import { Link } from 'react-router-dom';
import { ArrowUpRight, Info } from 'lucide-react';
import Shell from '../../components/Shell';
import Seo from '../../components/Seo';
import { PageHero, Section, CTA } from '../../components/Pieces';
import ProjectIcon from './ProjectIcon';
import { projectCards } from '../../data/projectsData';

export default function ProjectsListing() {
  return (
    <Shell>
      <Seo title="Projects"
        description="Mashmari project implementations: NIIT Foundation Mobile Education Bus, BBPS remote education, WCDD Haryana Digital Anganwadi Pilot, Satnavari Smart Intelligent Village and the project video library."
        image="/video-thumbs/video-09.jpg" />
      <PageHero
        kicker="Projects"
        title="Field implementations, evidence and documentation."
        sub="Programme deployments across schools, Anganwadi centres and village learning environments — with the completion artefacts and field footage published alongside them."
        breadcrumbs={[{ label: 'Projects' }]}
      />

      <Section bg="white">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="projects-grid">
          {projectCards.map((p) => (
            <ProjectCard key={p.id} project={p} />
          ))}
        </div>
      </Section>

      <CTA title="Want the full evidence pack for a programme?" primary={{ label: 'Talk to us', href: '/contact' }} />
    </Shell>
  );
}

function ProjectCard({ project }) {
  const inner = (
    <>
      <div className="flex items-start justify-between">
        <span className="w-14 h-14 rounded-2xl bg-[#F3E8FA] text-[var(--mm-purple)] flex items-center justify-center transition-colors group-hover:bg-[var(--mm-purple)] group-hover:text-white">
          <ProjectIcon name={project.icon} />
        </span>
        {project.to && <ArrowUpRight className="w-5 h-5 text-[var(--mm-ink)]/30 transition-all group-hover:text-[var(--mm-purple)] group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />}
      </div>
      <h3 className="mt-7 font-display text-xl md:text-[22px] font-bold text-[var(--mm-ink)] leading-snug">{project.title}</h3>
      <p className="mt-4 text-[15px] text-[var(--mm-ink)]/70 leading-relaxed">{project.body}</p>
      {project.unavailable && (
        <p className="mt-5 flex gap-2 text-xs text-[var(--mm-ink)]/50 leading-relaxed border-t border-[var(--mm-line)] pt-4">
          <Info className="w-3.5 h-3.5 shrink-0 mt-0.5" /> {project.unavailable}
        </p>
      )}
    </>
  );

  const base = 'group bg-white border border-[var(--mm-line)] rounded-2xl p-7 md:p-8 flex flex-col transition-all duration-300';

  if (!project.to) {
    return <article className={base} data-testid={`project-card-${project.id}`}>{inner}</article>;
  }
  return (
    <Link to={project.to} data-testid={`project-card-${project.id}`}
      className={`${base} hover:-translate-y-1.5 hover:shadow-[0_22px_48px_-26px_rgba(74,18,89,.4)] hover:border-[var(--mm-purple)]/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--mm-purple)] focus-visible:ring-offset-2`}>
      {inner}
    </Link>
  );
}
